@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(2_054_025_733)
internal val Res.string.exp_title_le_preposizioni: StringResource by lazy {
      StringResource("string:exp_title_le_preposizioni", "exp_title_le_preposizioni", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156905, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154321, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156582, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148429, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145065, 49),
      ))
    }

@delegate:ResourceContentHash(-1_990_664_111)
internal val Res.string.exp_title_le_vocali: StringResource by lazy {
      StringResource("string:exp_title_le_vocali", "exp_title_le_vocali", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156959, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154375, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156636, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148483, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145115, 43),
      ))
    }

@delegate:ResourceContentHash(1_027_036_699)
internal val Res.string.exp_title_lezione_completata: StringResource by lazy {
      StringResource("string:exp_title_lezione_completata", "exp_title_lezione_completata", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157003, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154419, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156680, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148523, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145159, 60),
      ))
    }

@delegate:ResourceContentHash(-1_005_126_506)
internal val Res.string.exp_title_liste_di_sostantivi: StringResource by lazy {
      StringResource("string:exp_title_liste_di_sostantivi", "exp_title_liste_di_sostantivi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157068, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154484, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156741, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148584, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145220, 57),
      ))
    }

@delegate:ResourceContentHash(515_947_246)
internal val Res.string.exp_title_mangiare: StringResource by lazy {
      StringResource("string:exp_title_mangiare", "exp_title_mangiare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157138, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154550, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156799, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148650, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145278, 30),
      ))
    }

@delegate:ResourceContentHash(317_429_848)
internal val Res.string.exp_title_maschile_vs_femminile: StringResource by lazy {
      StringResource("string:exp_title_maschile_vs_femminile", "exp_title_maschile_vs_femminile", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157173, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154585, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156834, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148689, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145309, 59),
      ))
    }

@delegate:ResourceContentHash(723_349_226)
internal val Res.string.exp_title_mettiti_alla_prova: StringResource by lazy {
      StringResource("string:exp_title_mettiti_alla_prova", "exp_title_mettiti_alla_prova", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157245, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154653, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156902, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148757, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145369, 56),
      ))
    }

@delegate:ResourceContentHash(878_230_851)
internal val Res.string.exp_title_mi_ti_srw: StringResource by lazy {
      StringResource("string:exp_title_mi_ti_srw", "exp_title_mi_ti_srw", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157306, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154714, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156955, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148822, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145426, 55),
      ))
    }

@delegate:ResourceContentHash(1_424_060_313)
internal val Res.string.exp_title_nilo: StringResource by lazy {
      StringResource("string:exp_title_nilo", "exp_title_nilo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157370, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154774, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157019, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148882, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145482, 30),
      ))
    }

@delegate:ResourceContentHash(-646_629_071)
internal val Res.string.exp_title_nomi_e_aggettivi_1: StringResource by lazy {
      StringResource("string:exp_title_nomi_e_aggettivi_1", "exp_title_nomi_e_aggettivi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157401, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154805, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157050, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148913, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145513, 68),
      ))
    }

@delegate:ResourceContentHash(1_321_537_763)
internal val Res.string.exp_title_nomi_importanti: StringResource by lazy {
      StringResource("string:exp_title_nomi_importanti", "exp_title_nomi_importanti", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157466, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154878, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157115, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148974, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145582, 53),
      ))
    }

@delegate:ResourceContentHash(218_049_954)
internal val Res.string.exp_title_nomi_nomi_nomi: StringResource by lazy {
      StringResource("string:exp_title_nomi_nomi_nomi", "exp_title_nomi_nomi_nomi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157520, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154940, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157177, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149028, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145636, 60),
      ))
    }

@delegate:ResourceContentHash(-1_010_808_310)
internal val Res.string.exp_title_non_preoccuparti_per_ora: StringResource by lazy {
      StringResource("string:exp_title_non_preoccuparti_per_ora", "exp_title_non_preoccuparti_per_ora", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157581, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155013, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157250, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149085, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145697, 70),
      ))
    }

@delegate:ResourceContentHash(591_000_131)
internal val Res.string.exp_title_numero: StringResource by lazy {
      StringResource("string:exp_title_numero", "exp_title_numero", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157660, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155092, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157341, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149164, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145768, 32),
      ))
    }

@delegate:ResourceContentHash(-1_580_057_208)
internal val Res.string.exp_title_oggetto_frase: StringResource by lazy {
      StringResource("string:exp_title_oggetto_frase", "exp_title_oggetto_frase", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157693, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155129, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157374, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149197, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145801, 67),
      ))
    }

@delegate:ResourceContentHash(1_714_792_681)
internal val Res.string.exp_title_omissioni_e_abbreviazioni: StringResource by lazy {
      StringResource("string:exp_title_omissioni_e_abbreviazioni", "exp_title_omissioni_e_abbreviazioni", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157753, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155189, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157434, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149257, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145869, 79),
      ))
    }

@delegate:ResourceContentHash(-1_153_982_374)
internal val Res.string.exp_title_orientamento: StringResource by lazy {
      StringResource("string:exp_title_orientamento", "exp_title_orientamento", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157837, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155269, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157514, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149337, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145949, 46),
      ))
    }

@delegate:ResourceContentHash(1_732_062_334)
internal val Res.string.exp_title_parole_del_tempo: StringResource by lazy {
      StringResource("string:exp_title_parole_del_tempo", "exp_title_parole_del_tempo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157884, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155316, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149384, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145996, 54),
      ))
    }

@delegate:ResourceContentHash(-2_126_891_608)
internal val Res.string.exp_title_parole_di_luoghi: StringResource by lazy {
      StringResource("string:exp_title_parole_di_luoghi", "exp_title_parole_di_luoghi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 157943, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155379, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157561, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149443, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146051, 54),
      ))
    }

@delegate:ResourceContentHash(1_567_619_341)
internal val Res.string.exp_title_parole_varie: StringResource by lazy {
      StringResource("string:exp_title_parole_varie", "exp_title_parole_varie", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158002, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155442, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157616, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149502, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146106, 50),
      ))
    }

@delegate:ResourceContentHash(-1_454_463_697)
internal val Res.string.exp_title_participi_intro: StringResource by lazy {
      StringResource("string:exp_title_participi_intro", "exp_title_participi_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158061, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155493, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157663, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149549, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146157, 49),
      ))
    }

@delegate:ResourceContentHash(1_107_238_088)
internal val Res.string.exp_title_particle_iw: StringResource by lazy {
      StringResource("string:exp_title_particle_iw", "exp_title_particle_iw", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158111, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155547, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157713, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149599, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146207, 53),
      ))
    }

@delegate:ResourceContentHash(1_777_659_282)
internal val Res.string.exp_title_possessivo_suffisso: StringResource by lazy {
      StringResource("string:exp_title_possessivo_suffisso", "exp_title_possessivo_suffisso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158165, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155601, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157767, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149653, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146261, 53),
      ))
    }

@delegate:ResourceContentHash(-70_261_631)
internal val Res.string.exp_title_preposizione_dr: StringResource by lazy {
      StringResource("string:exp_title_preposizione_dr", "exp_title_preposizione_dr", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158223, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155659, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157821, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149707, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146315, 61),
      ))
    }

@delegate:ResourceContentHash(542_160_070)
internal val Res.string.exp_title_preposizione_hr: StringResource by lazy {
      StringResource("string:exp_title_preposizione_hr", "exp_title_preposizione_hr", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158285, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155721, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157883, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149769, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146377, 61),
      ))
    }

@delegate:ResourceContentHash(-1_277_199_989)
internal val Res.string.exp_title_preposizione_m: StringResource by lazy {
      StringResource("string:exp_title_preposizione_m", "exp_title_preposizione_m", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158413, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155849, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 157945, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149897, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146505, 60),
      ))
    }

@delegate:ResourceContentHash(-1_589_856_536)
internal val Res.string.exp_title_preposizione_m_locativa: StringResource by lazy {
      StringResource("string:exp_title_preposizione_m_locativa", "exp_title_preposizione_m_locativa", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158347, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155783, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149831, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146439, 65),
      ))
    }

@delegate:ResourceContentHash(707_364_533)
internal val Res.string.exp_title_rafforzare_i_suoni: StringResource by lazy {
      StringResource("string:exp_title_rafforzare_i_suoni", "exp_title_rafforzare_i_suoni", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158541, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155977, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158069, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150017, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146633, 64),
      ))
    }

@delegate:ResourceContentHash(-1_472_441_179)
internal val Res.string.exp_title_rafforzare_i_suoni_2: StringResource by lazy {
      StringResource("string:exp_title_rafforzare_i_suoni_2", "exp_title_rafforzare_i_suoni_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158474, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155910, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158006, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 149954, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146566, 66),
      ))
    }

@delegate:ResourceContentHash(37_687_716)
internal val Res.string.exp_title_recap_frasi_pseudoverbali: StringResource by lazy {
      StringResource("string:exp_title_recap_frasi_pseudoverbali", "exp_title_recap_frasi_pseudoverbali", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158606, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156042, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158130, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150078, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146698, 51),
      ))
    }

@delegate:ResourceContentHash(-1_161_831_248)
internal val Res.string.exp_title_recap_imperfettivo: StringResource by lazy {
      StringResource("string:exp_title_recap_imperfettivo", "exp_title_recap_imperfettivo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158666, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156094, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158186, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150134, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146750, 44),
      ))
    }

@delegate:ResourceContentHash(932_485_886)
internal val Res.string.exp_title_recap_verbi_participi: StringResource by lazy {
      StringResource("string:exp_title_recap_verbi_participi", "exp_title_recap_verbi_participi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158715, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156147, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158235, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150187, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146795, 59),
      ))
    }

@delegate:ResourceContentHash(2_125_175_379)
internal val Res.string.exp_title_recap_vso: StringResource by lazy {
      StringResource("string:exp_title_recap_vso", "exp_title_recap_vso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158787, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156207, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158307, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150251, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146855, 43),
      ))
    }

@delegate:ResourceContentHash(-269_817_301)
internal val Res.string.exp_title_rieccolo_di_nuovo: StringResource by lazy {
      StringResource("string:exp_title_rieccolo_di_nuovo", "exp_title_rieccolo_di_nuovo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158851, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156255, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158351, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150295, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146899, 59),
      ))
    }

@delegate:ResourceContentHash(856_626_995)
internal val Res.string.exp_title_ripassino_aggettivi: StringResource by lazy {
      StringResource("string:exp_title_ripassino_aggettivi", "exp_title_ripassino_aggettivi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158911, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156323, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158407, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150355, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146959, 53),
      ))
    }

@delegate:ResourceContentHash(634_029_783)
internal val Res.string.exp_title_ripasso_genere_e_numero: StringResource by lazy {
      StringResource("string:exp_title_ripasso_genere_e_numero", "exp_title_ripasso_genere_e_numero", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 158961, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156389, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158461, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150409, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147013, 77),
      ))
    }

@delegate:ResourceContentHash(689_550_520)
internal val Res.string.exp_title_scorta_di_aggettivi: StringResource by lazy {
      StringResource("string:exp_title_scorta_di_aggettivi", "exp_title_scorta_di_aggettivi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159047, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156467, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158539, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150483, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147091, 73),
      ))
    }

@delegate:ResourceContentHash(-985_026_623)
internal val Res.string.exp_title_sdm_f_congiuntivo: StringResource by lazy {
      StringResource("string:exp_title_sdm_f_congiuntivo", "exp_title_sdm_f_congiuntivo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159105, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156533, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158605, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150549, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147165, 47),
      ))
    }

@delegate:ResourceContentHash(-196_410_059)
internal val Res.string.exp_title_sdm_f_intro: StringResource by lazy {
      StringResource("string:exp_title_sdm_f_intro", "exp_title_sdm_f_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159161, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156581, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158661, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150597, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147213, 61),
      ))
    }

@delegate:ResourceContentHash(-550_488_099)
internal val Res.string.exp_title_segni_degli_aggettivi: StringResource by lazy {
      StringResource("string:exp_title_segni_degli_aggettivi", "exp_title_segni_degli_aggettivi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159223, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156643, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158723, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150659, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147275, 67),
      ))
    }

@delegate:ResourceContentHash(-609_528_222)
internal val Res.string.exp_title_segni_vari: StringResource by lazy {
      StringResource("string:exp_title_segni_vari", "exp_title_segni_vari", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159360, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156776, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158860, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150784, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147400, 48),
      ))
    }

@delegate:ResourceContentHash(-938_962_356)
internal val Res.string.exp_title_segni_vari_iii: StringResource by lazy {
      StringResource("string:exp_title_segni_vari_iii", "exp_title_segni_vari_iii", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159295, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156719, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158803, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150731, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147343, 56),
      ))
    }

@delegate:ResourceContentHash(-1_254_363_355)
internal val Res.string.exp_title_seven_ending: StringResource by lazy {
      StringResource("string:exp_title_seven_ending", "exp_title_seven_ending", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159417, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156825, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158909, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150829, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147449, 42),
      ))
    }

@delegate:ResourceContentHash(775_451_494)
internal val Res.string.exp_title_significato_dei_nomi: StringResource by lazy {
      StringResource("string:exp_title_significato_dei_nomi", "exp_title_significato_dei_nomi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159468, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156872, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 158956, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150880, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147492, 66),
      ))
    }

@delegate:ResourceContentHash(1_238_811_076)
internal val Res.string.exp_title_singolare_vs_plurale: StringResource by lazy {
      StringResource("string:exp_title_singolare_vs_plurale", "exp_title_singolare_vs_plurale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159539, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 156951, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159019, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 150951, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147559, 62),
      ))
    }

@delegate:ResourceContentHash(337_206_802)
internal val Res.string.exp_title_soggetto_esplicito: StringResource by lazy {
      StringResource("string:exp_title_soggetto_esplicito", "exp_title_soggetto_esplicito", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159606, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157014, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159086, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151018, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147622, 64),
      ))
    }

@delegate:ResourceContentHash(-934_412_892)
internal val Res.string.exp_title_symbol: StringResource by lazy {
      StringResource("string:exp_title_symbol", "exp_title_symbol", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159716, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157124, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159192, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151128, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147732, 32),
      ))
    }

@delegate:ResourceContentHash(-934_412_892)
internal val Res.string.exp_title_symbol_placeholder: StringResource by lazy {
      StringResource("string:exp_title_symbol_placeholder", "exp_title_symbol_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159671, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157079, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159147, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151083, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147687, 44),
      ))
    }

@delegate:ResourceContentHash(-318_841_398)
internal val Res.string.exp_title_tempio_possedimento: StringResource by lazy {
      StringResource("string:exp_title_tempio_possedimento", "exp_title_tempio_possedimento", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159749, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157157, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159225, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151161, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147765, 65),
      ))
    }

@delegate:ResourceContentHash(-22_623_867)
internal val Res.string.exp_title_terra: StringResource by lazy {
      StringResource("string:exp_title_terra", "exp_title_terra", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159807, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157219, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159291, 31),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151227, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147831, 31),
      ))
    }

@delegate:ResourceContentHash(1_372_282_742)
internal val Res.string.exp_title_torniamo_alla_grammatica: StringResource by lazy {
      StringResource("string:exp_title_torniamo_alla_grammatica", "exp_title_torniamo_alla_grammatica", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159839, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157251, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159323, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151259, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147863, 62),
      ))
    }

@delegate:ResourceContentHash(-987_793_363)
internal val Res.string.exp_title_tradizione_e_simmetria: StringResource by lazy {
      StringResource("string:exp_title_tradizione_e_simmetria", "exp_title_tradizione_e_simmetria", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159910, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157326, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159398, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151334, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147926, 72),
      ))
    }

@delegate:ResourceContentHash(1_662_744_138)
internal val Res.string.exp_title_traduciamo_i_nomi: StringResource by lazy {
      StringResource("string:exp_title_traduciamo_i_nomi", "exp_title_traduciamo_i_nomi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 159983, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157399, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159471, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151407, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147999, 71),
      ))
    }

@delegate:ResourceContentHash(-576_829_060)
internal val Res.string.exp_title_tutto_insieme_ora: StringResource by lazy {
      StringResource("string:exp_title_tutto_insieme_ora", "exp_title_tutto_insieme_ora", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160055, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157471, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159535, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151467, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148071, 59),
      ))
    }

@delegate:ResourceContentHash(-1_471_905_511)
internal val Res.string.exp_title_un_attimo: StringResource by lazy {
      StringResource("string:exp_title_un_attimo", "exp_title_un_attimo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160119, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157531, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159603, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151527, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148131, 47),
      ))
    }

@delegate:ResourceContentHash(1_415_212_449)
internal val Res.string.exp_title_un_seguace_eccellente: StringResource by lazy {
      StringResource("string:exp_title_un_seguace_eccellente", "exp_title_un_seguace_eccellente", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160167, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157579, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159647, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151571, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148179, 67),
      ))
    }

@delegate:ResourceContentHash(104_748_051)
internal val Res.string.exp_title_una_definizione: StringResource by lazy {
      StringResource("string:exp_title_una_definizione", "exp_title_una_definizione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160247, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157647, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159715, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151639, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148247, 49),
      ))
    }

@delegate:ResourceContentHash(-1_218_180_418)
internal val Res.string.exp_title_una_soluzione_utile: StringResource by lazy {
      StringResource("string:exp_title_una_soluzione_utile", "exp_title_una_soluzione_utile", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160301, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157701, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159769, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151693, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148297, 61),
      ))
    }

@delegate:ResourceContentHash(142_726_834)
internal val Res.string.exp_title_uscire: StringResource by lazy {
      StringResource("string:exp_title_uscire", "exp_title_uscire", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160371, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157767, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159831, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151759, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148359, 32),
      ))
    }

@delegate:ResourceContentHash(401_152_663)
internal val Res.string.exp_title_verbi_e_participi: StringResource by lazy {
      StringResource("string:exp_title_verbi_e_participi", "exp_title_verbi_e_participi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160412, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157800, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159864, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151792, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148392, 63),
      ))
    }

@delegate:ResourceContentHash(1_122_367_472)
internal val Res.string.exp_title_verbi_intro_1: StringResource by lazy {
      StringResource("string:exp_title_verbi_intro_1", "exp_title_verbi_intro_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160480, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157864, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 159928, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151852, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148456, 67),
      ))
    }

@delegate:ResourceContentHash(1_329_386_233)
internal val Res.string.exp_title_verbi_sostantivati: StringResource by lazy {
      StringResource("string:exp_title_verbi_sostantivati", "exp_title_verbi_sostantivati", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160556, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157936, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160004, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151920, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148524, 64),
      ))
    }

@delegate:ResourceContentHash(-716_555_057)
internal val Res.string.exp_title_vocab_pronomi_suffissi_intro: StringResource by lazy {
      StringResource("string:exp_title_vocab_pronomi_suffissi_intro", "exp_title_vocab_pronomi_suffissi_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160625, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158001, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160069, 70),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 151981, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148589, 66),
      ))
    }

@delegate:ResourceContentHash(1_821_586_233)
internal val Res.string.exp_title_vocab_vari_1_intro: StringResource by lazy {
      StringResource("string:exp_title_vocab_vari_1_intro", "exp_title_vocab_vari_1_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160692, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158080, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160140, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152052, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148656, 56),
      ))
    }

@delegate:ResourceContentHash(-1_301_618_655)
internal val Res.string.exp_title_vocab_vari_2_intro: StringResource by lazy {
      StringResource("string:exp_title_vocab_vari_2_intro", "exp_title_vocab_vari_2_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160757, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158145, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160197, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152113, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148713, 60),
      ))
    }

@delegate:ResourceContentHash(949_185_194)
internal val Res.string.exp_title_vocab_verbs_1_intro: StringResource by lazy {
      StringResource("string:exp_title_vocab_verbs_1_intro", "exp_title_vocab_verbs_1_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160822, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158210, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160254, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152174, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148774, 65),
      ))
    }

@delegate:ResourceContentHash(1_389_951_128)
internal val Res.string.exp_title_vocab_verbs_2_intro: StringResource by lazy {
      StringResource("string:exp_title_vocab_verbs_2_intro", "exp_title_vocab_verbs_2_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160888, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158276, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160324, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152240, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148840, 65),
      ))
    }

@delegate:ResourceContentHash(-435_202_598)
internal val Res.string.exp_title_vocab_verbs_3_intro: StringResource by lazy {
      StringResource("string:exp_title_vocab_verbs_3_intro", "exp_title_vocab_verbs_3_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 160954, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158346, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160394, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152306, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148906, 65),
      ))
    }

@delegate:ResourceContentHash(399_730_059)
internal val Res.string.exp_title_vocab_verbs_4_intro: StringResource by lazy {
      StringResource("string:exp_title_vocab_verbs_4_intro", "exp_title_vocab_verbs_4_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161024, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158416, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160464, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152376, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 148972, 65),
      ))
    }

@delegate:ResourceContentHash(-128_541_902)
internal val Res.string.exp_title_vocab_vso_1_intro: StringResource by lazy {
      StringResource("string:exp_title_vocab_vso_1_intro", "exp_title_vocab_vso_1_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161090, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158486, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160534, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152442, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149038, 51),
      ))
    }

@delegate:ResourceContentHash(1_752_072_312)
internal val Res.string.exp_title_vocab_vso_2_intro: StringResource by lazy {
      StringResource("string:exp_title_vocab_vso_2_intro", "exp_title_vocab_vso_2_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161146, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158546, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160590, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152498, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149090, 59),
      ))
    }

@delegate:ResourceContentHash(-1_639_056_622)
internal val Res.string.exp_title_vocab_vso_3_intro: StringResource by lazy {
      StringResource("string:exp_title_vocab_vso_3_intro", "exp_title_vocab_vso_3_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161214, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158606, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160650, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152554, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149150, 59),
      ))
    }

@delegate:ResourceContentHash(207_576_874)
internal val Res.string.exp_title_vocabolario_animali: StringResource by lazy {
      StringResource("string:exp_title_vocabolario_animali", "exp_title_vocabolario_animali", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161274, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158666, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160710, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152610, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149210, 65),
      ))
    }

@delegate:ResourceContentHash(1_313_499_653)
internal val Res.string.exp_title_vocabolario_cibo: StringResource by lazy {
      StringResource("string:exp_title_vocabolario_cibo", "exp_title_vocabolario_cibo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161336, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158732, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160776, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152676, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149276, 58),
      ))
    }

@delegate:ResourceContentHash(-1_371_859_392)
internal val Res.string.exp_title_vocabolario_luoghi_e_oggetti: StringResource by lazy {
      StringResource("string:exp_title_vocabolario_luoghi_e_oggetti", "exp_title_vocabolario_luoghi_e_oggetti", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161395, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158795, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160843, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152735, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149335, 86),
      ))
    }

@delegate:ResourceContentHash(-709_773_268)
internal val Res.string.exp_title_vocabolario_umani: StringResource by lazy {
      StringResource("string:exp_title_vocabolario_umani", "exp_title_vocabolario_umani", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161486, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158882, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160930, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152822, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149422, 59),
      ))
    }

@delegate:ResourceContentHash(1_693_762_950)
internal val Res.string.exp_title_vocabolario_verbi_base: StringResource by lazy {
      StringResource("string:exp_title_vocabolario_verbi_base", "exp_title_vocabolario_verbi_base", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161550, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 158946, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 160994, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152882, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149482, 72),
      ))
    }

@delegate:ResourceContentHash(-934_412_892)
internal val Res.string.exp_title_word_name: StringResource by lazy {
      StringResource("string:exp_title_word_name", "exp_title_word_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161623, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159027, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161075, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152955, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149555, 35),
      ))
    }

@delegate:ResourceContentHash(1_756_985_821)
internal val Res.string.face_cry: StringResource by lazy {
      StringResource("string:face_cry", "face_cry", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161659, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159063, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161111, 28),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 152991, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149591, 24),
      ))
    }

@delegate:ResourceContentHash(1_873_250_057)
internal val Res.string.face_doubt: StringResource by lazy {
      StringResource("string:face_doubt", "face_doubt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161688, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159092, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161140, 26),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153016, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149616, 26),
      ))
    }

@delegate:ResourceContentHash(1_571_473_713)
internal val Res.string.face_happy: StringResource by lazy {
      StringResource("string:face_happy", "face_happy", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161719, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159119, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161167, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153047, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149643, 26),
      ))
    }

@delegate:ResourceContentHash(-1_460_208_041)
internal val Res.string.face_idle: StringResource by lazy {
      StringResource("string:face_idle", "face_idle", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161754, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159146, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161198, 25),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153074, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149670, 25),
      ))
    }

@delegate:ResourceContentHash(-838_285_596)
internal val Res.string.face_nilo_sleepy: StringResource by lazy {
      StringResource("string:face_nilo_sleepy", "face_nilo_sleepy", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161780, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159172, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161224, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153100, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149696, 32),
      ))
    }

@delegate:ResourceContentHash(1_692_023_211)
internal val Res.string.face_perfect: StringResource by lazy {
      StringResource("string:face_perfect", "face_perfect", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161813, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159213, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161261, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153137, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149729, 32),
      ))
    }

@delegate:ResourceContentHash(-121_920_985)
internal val Res.string.face_sad: StringResource by lazy {
      StringResource("string:face_sad", "face_sad", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161846, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159246, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161294, 24),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153170, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149762, 20),
      ))
    }

@delegate:ResourceContentHash(-1_207_163_983)
internal val Res.string.face_serious: StringResource by lazy {
      StringResource("string:face_serious", "face_serious", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161875, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159271, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161319, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153195, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149783, 32),
      ))
    }

@delegate:ResourceContentHash(-1_513_205_997)
internal val Res.string.face_sleeping: StringResource by lazy {
      StringResource("string:face_sleeping", "face_sleeping", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161904, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159300, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161352, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153224, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149816, 33),
      ))
    }

@delegate:ResourceContentHash(1_058_244_227)
internal val Res.string.face_surprised: StringResource by lazy {
      StringResource("string:face_surprised", "face_surprised", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161938, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159334, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161386, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153262, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149850, 34),
      ))
    }

@delegate:ResourceContentHash(-498_585_023)
internal val Res.string.false_option: StringResource by lazy {
      StringResource("string:false_option", "false_option", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 161977, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159373, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161421, 28),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153297, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149885, 28),
      ))
    }

@delegate:ResourceContentHash(-1_814_083_189)
internal val Res.string.fantastic_btn: StringResource by lazy {
      StringResource("string:fantastic_btn", "fantastic_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162006, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159402, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161450, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153326, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149914, 37),
      ))
    }

@delegate:ResourceContentHash(-879_400_490)
internal val Res.string.favorite_badge_desc: StringResource by lazy {
      StringResource("string:favorite_badge_desc", "favorite_badge_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162044, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159444, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161492, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153364, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149952, 39),
      ))
    }

@delegate:ResourceContentHash(46_244_938)
internal val Res.string.feature_poll_btn_skip: StringResource by lazy {
      StringResource("string:feature_poll_btn_skip", "feature_poll_btn_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162084, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159484, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161528, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153404, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149992, 41),
      ))
    }

@delegate:ResourceContentHash(404_516_083)
internal val Res.string.feature_poll_cta_button: StringResource by lazy {
      StringResource("string:feature_poll_cta_button", "feature_poll_cta_button", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162130, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159526, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161578, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153446, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150034, 39),
      ))
    }

@delegate:ResourceContentHash(-1_376_921_734)
internal val Res.string.feature_poll_cta_text: StringResource by lazy {
      StringResource("string:feature_poll_cta_text", "feature_poll_cta_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162174, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159566, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161618, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153486, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150074, 77),
      ))
    }

@delegate:ResourceContentHash(1_538_849_464)
internal val Res.string.feature_poll_free_text_label: StringResource by lazy {
      StringResource("string:feature_poll_free_text_label", "feature_poll_free_text_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162272, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159664, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161704, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153568, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150152, 76),
      ))
    }

@delegate:ResourceContentHash(-744_508_430)
internal val Res.string.feature_poll_option_character_accessories: StringResource by lazy {
      StringResource("string:feature_poll_option_character_accessories", "feature_poll_option_character_accessories", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162349, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159741, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161777, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153633, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150229, 85),
      ))
    }

@delegate:ResourceContentHash(-449_907_515)
internal val Res.string.feature_poll_option_new_chapters: StringResource by lazy {
      StringResource("string:feature_poll_option_new_chapters", "feature_poll_option_new_chapters", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162431, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159843, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161875, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153727, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150315, 56),
      ))
    }

@delegate:ResourceContentHash(1_007_325_962)
internal val Res.string.feature_poll_option_new_quiz_modes: StringResource by lazy {
      StringResource("string:feature_poll_option_new_quiz_modes", "feature_poll_option_new_quiz_modes", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162488, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159908, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161940, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153788, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150372, 62),
      ))
    }

@delegate:ResourceContentHash(-1_016_766_347)
internal val Res.string.feature_poll_option_review_section: StringResource by lazy {
      StringResource("string:feature_poll_option_review_section", "feature_poll_option_review_section", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162551, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 159979, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 162015, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153863, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150435, 66),
      ))
    }

@delegate:ResourceContentHash(738_609_878)
internal val Res.string.feature_poll_submit_button: StringResource by lazy {
      StringResource("string:feature_poll_submit_button", "feature_poll_submit_button", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162626, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160054, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 162090, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153934, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150502, 42),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString14Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_title_le_preposizioni", Res.string.exp_title_le_preposizioni)
  map.put("exp_title_le_vocali", Res.string.exp_title_le_vocali)
  map.put("exp_title_lezione_completata", Res.string.exp_title_lezione_completata)
  map.put("exp_title_liste_di_sostantivi", Res.string.exp_title_liste_di_sostantivi)
  map.put("exp_title_mangiare", Res.string.exp_title_mangiare)
  map.put("exp_title_maschile_vs_femminile", Res.string.exp_title_maschile_vs_femminile)
  map.put("exp_title_mettiti_alla_prova", Res.string.exp_title_mettiti_alla_prova)
  map.put("exp_title_mi_ti_srw", Res.string.exp_title_mi_ti_srw)
  map.put("exp_title_nilo", Res.string.exp_title_nilo)
  map.put("exp_title_nomi_e_aggettivi_1", Res.string.exp_title_nomi_e_aggettivi_1)
  map.put("exp_title_nomi_importanti", Res.string.exp_title_nomi_importanti)
  map.put("exp_title_nomi_nomi_nomi", Res.string.exp_title_nomi_nomi_nomi)
  map.put("exp_title_non_preoccuparti_per_ora", Res.string.exp_title_non_preoccuparti_per_ora)
  map.put("exp_title_numero", Res.string.exp_title_numero)
  map.put("exp_title_oggetto_frase", Res.string.exp_title_oggetto_frase)
  map.put("exp_title_omissioni_e_abbreviazioni", Res.string.exp_title_omissioni_e_abbreviazioni)
  map.put("exp_title_orientamento", Res.string.exp_title_orientamento)
  map.put("exp_title_parole_del_tempo", Res.string.exp_title_parole_del_tempo)
  map.put("exp_title_parole_di_luoghi", Res.string.exp_title_parole_di_luoghi)
  map.put("exp_title_parole_varie", Res.string.exp_title_parole_varie)
  map.put("exp_title_participi_intro", Res.string.exp_title_participi_intro)
  map.put("exp_title_particle_iw", Res.string.exp_title_particle_iw)
  map.put("exp_title_possessivo_suffisso", Res.string.exp_title_possessivo_suffisso)
  map.put("exp_title_preposizione_dr", Res.string.exp_title_preposizione_dr)
  map.put("exp_title_preposizione_hr", Res.string.exp_title_preposizione_hr)
  map.put("exp_title_preposizione_m", Res.string.exp_title_preposizione_m)
  map.put("exp_title_preposizione_m_locativa", Res.string.exp_title_preposizione_m_locativa)
  map.put("exp_title_rafforzare_i_suoni", Res.string.exp_title_rafforzare_i_suoni)
  map.put("exp_title_rafforzare_i_suoni_2", Res.string.exp_title_rafforzare_i_suoni_2)
  map.put("exp_title_recap_frasi_pseudoverbali", Res.string.exp_title_recap_frasi_pseudoverbali)
  map.put("exp_title_recap_imperfettivo", Res.string.exp_title_recap_imperfettivo)
  map.put("exp_title_recap_verbi_participi", Res.string.exp_title_recap_verbi_participi)
  map.put("exp_title_recap_vso", Res.string.exp_title_recap_vso)
  map.put("exp_title_rieccolo_di_nuovo", Res.string.exp_title_rieccolo_di_nuovo)
  map.put("exp_title_ripassino_aggettivi", Res.string.exp_title_ripassino_aggettivi)
  map.put("exp_title_ripasso_genere_e_numero", Res.string.exp_title_ripasso_genere_e_numero)
  map.put("exp_title_scorta_di_aggettivi", Res.string.exp_title_scorta_di_aggettivi)
  map.put("exp_title_sdm_f_congiuntivo", Res.string.exp_title_sdm_f_congiuntivo)
  map.put("exp_title_sdm_f_intro", Res.string.exp_title_sdm_f_intro)
  map.put("exp_title_segni_degli_aggettivi", Res.string.exp_title_segni_degli_aggettivi)
  map.put("exp_title_segni_vari", Res.string.exp_title_segni_vari)
  map.put("exp_title_segni_vari_iii", Res.string.exp_title_segni_vari_iii)
  map.put("exp_title_seven_ending", Res.string.exp_title_seven_ending)
  map.put("exp_title_significato_dei_nomi", Res.string.exp_title_significato_dei_nomi)
  map.put("exp_title_singolare_vs_plurale", Res.string.exp_title_singolare_vs_plurale)
  map.put("exp_title_soggetto_esplicito", Res.string.exp_title_soggetto_esplicito)
  map.put("exp_title_symbol", Res.string.exp_title_symbol)
  map.put("exp_title_symbol_placeholder", Res.string.exp_title_symbol_placeholder)
  map.put("exp_title_tempio_possedimento", Res.string.exp_title_tempio_possedimento)
  map.put("exp_title_terra", Res.string.exp_title_terra)
  map.put("exp_title_torniamo_alla_grammatica", Res.string.exp_title_torniamo_alla_grammatica)
  map.put("exp_title_tradizione_e_simmetria", Res.string.exp_title_tradizione_e_simmetria)
  map.put("exp_title_traduciamo_i_nomi", Res.string.exp_title_traduciamo_i_nomi)
  map.put("exp_title_tutto_insieme_ora", Res.string.exp_title_tutto_insieme_ora)
  map.put("exp_title_un_attimo", Res.string.exp_title_un_attimo)
  map.put("exp_title_un_seguace_eccellente", Res.string.exp_title_un_seguace_eccellente)
  map.put("exp_title_una_definizione", Res.string.exp_title_una_definizione)
  map.put("exp_title_una_soluzione_utile", Res.string.exp_title_una_soluzione_utile)
  map.put("exp_title_uscire", Res.string.exp_title_uscire)
  map.put("exp_title_verbi_e_participi", Res.string.exp_title_verbi_e_participi)
  map.put("exp_title_verbi_intro_1", Res.string.exp_title_verbi_intro_1)
  map.put("exp_title_verbi_sostantivati", Res.string.exp_title_verbi_sostantivati)
  map.put("exp_title_vocab_pronomi_suffissi_intro", Res.string.exp_title_vocab_pronomi_suffissi_intro)
  map.put("exp_title_vocab_vari_1_intro", Res.string.exp_title_vocab_vari_1_intro)
  map.put("exp_title_vocab_vari_2_intro", Res.string.exp_title_vocab_vari_2_intro)
  map.put("exp_title_vocab_verbs_1_intro", Res.string.exp_title_vocab_verbs_1_intro)
  map.put("exp_title_vocab_verbs_2_intro", Res.string.exp_title_vocab_verbs_2_intro)
  map.put("exp_title_vocab_verbs_3_intro", Res.string.exp_title_vocab_verbs_3_intro)
  map.put("exp_title_vocab_verbs_4_intro", Res.string.exp_title_vocab_verbs_4_intro)
  map.put("exp_title_vocab_vso_1_intro", Res.string.exp_title_vocab_vso_1_intro)
  map.put("exp_title_vocab_vso_2_intro", Res.string.exp_title_vocab_vso_2_intro)
  map.put("exp_title_vocab_vso_3_intro", Res.string.exp_title_vocab_vso_3_intro)
  map.put("exp_title_vocabolario_animali", Res.string.exp_title_vocabolario_animali)
  map.put("exp_title_vocabolario_cibo", Res.string.exp_title_vocabolario_cibo)
  map.put("exp_title_vocabolario_luoghi_e_oggetti", Res.string.exp_title_vocabolario_luoghi_e_oggetti)
  map.put("exp_title_vocabolario_umani", Res.string.exp_title_vocabolario_umani)
  map.put("exp_title_vocabolario_verbi_base", Res.string.exp_title_vocabolario_verbi_base)
  map.put("exp_title_word_name", Res.string.exp_title_word_name)
  map.put("face_cry", Res.string.face_cry)
  map.put("face_doubt", Res.string.face_doubt)
  map.put("face_happy", Res.string.face_happy)
  map.put("face_idle", Res.string.face_idle)
  map.put("face_nilo_sleepy", Res.string.face_nilo_sleepy)
  map.put("face_perfect", Res.string.face_perfect)
  map.put("face_sad", Res.string.face_sad)
  map.put("face_serious", Res.string.face_serious)
  map.put("face_sleeping", Res.string.face_sleeping)
  map.put("face_surprised", Res.string.face_surprised)
  map.put("false_option", Res.string.false_option)
  map.put("fantastic_btn", Res.string.fantastic_btn)
  map.put("favorite_badge_desc", Res.string.favorite_badge_desc)
  map.put("feature_poll_btn_skip", Res.string.feature_poll_btn_skip)
  map.put("feature_poll_cta_button", Res.string.feature_poll_cta_button)
  map.put("feature_poll_cta_text", Res.string.feature_poll_cta_text)
  map.put("feature_poll_free_text_label", Res.string.feature_poll_free_text_label)
  map.put("feature_poll_option_character_accessories", Res.string.feature_poll_option_character_accessories)
  map.put("feature_poll_option_new_chapters", Res.string.feature_poll_option_new_chapters)
  map.put("feature_poll_option_new_quiz_modes", Res.string.feature_poll_option_new_quiz_modes)
  map.put("feature_poll_option_review_section", Res.string.feature_poll_option_review_section)
  map.put("feature_poll_submit_button", Res.string.feature_poll_submit_button)
}
